import { LocationDescriptorObject } from 'history';
import noop from 'lodash/noop';
import { ReactNode } from 'react';
import { ApiPageData, RootState } from './types';

export type ModalState = {
  pageId?: string;
  routeId?: string;
  formId?: string;
  title?: string;
  subtitle?: string;
  modal?: boolean;
  message?: string;
  target_id?: string;
  id?: string;
  url?: string;
};

export type ModalStateOptions = {
  headerTitle?: string;
  headerDescription?: string;
  headerColor?: string;
  content?: ReactNode;
  pageData?: ApiPageData;
  formData?: any;
  formProps?: any;
};

export type ModalMethodsOptions<F = any> = {
  loadRawPageData?: () => Promise<F>;
  getRawPageData?: (state: RootState) => F;
  transformRawPageData?: (data: F) => ApiPageData;
  submit?: (
    values: { [key: string]: any },
    options: { handleClose?: () => void }
  ) => void;
  getHeader?: (pageData: any) => { title: string; description: string };
};

export type ModalOptions = ModalStateOptions & ModalMethodsOptions;

export type ExtraLocationDescriptorOptions = {
  state?: ModalState;
  modal?: ModalStateOptions;
  methods?: ModalMethodsOptions;
};

type RoutesTable = {
  [routeId: string]: LocationDescriptorObject & ExtraLocationDescriptorOptions;
};

const routes: RoutesTable = {
  Home: {
    pathname: '/'
  },
  Login: {
    pathname: '/login'
  },
  Register: {
    pathname: '/register'
  },
  ForgotPassword: {
    pathname: '/forgot-password'
  },
  ResetPassword: {
    pathname: '/reset-password'
  },
  SavingHome: {
    pathname: '/savings'
  },
  SavingsHome: {
    pathname: '/savings'
  },
  PiggyBankHome: {
    pathname: '/savings/piggybank'
  },
  PiggybankLand: {
    pathname: '/savings/piggybank'
  },
  TargetsHome: {
    pathname: '/savings/targets'
  },
  TargetLand: {
    pathname: '/savings/targets'
  },
  TargetSavings: {
    pathname: '/savings/targets'
  },
  TargetsExplore: {
    pathname: '/savings/targets/explore'
  },
  SafelockHome: {
    pathname: '/savings/safelock'
  },
  SafeLockLand: {
    pathname: '/savings/safelock'
  },
  Safelocks: {
    pathname: '/savings/safelock'
  },
  FlexHome: {
    pathname: '/savings/flex'
  },
  FlexLand: {
    pathname: '/savings/flex'
  },
  MyInvest: {
    pathname: '/investify'
  },
  ExploreInvestify: {
    pathname: '/investify/explore'
  },
  CompletedInvestify: {
    pathname: '/investify/completed'
  },
  Settings: {
    pathname: '/settings'
  },
  LogOut: {
    pathname: '/logout'
  }
};

export default routes;

export const registerModalRoute = (
  routeId: string,
  pathname: string,
  modalOptions?: ModalOptions & ModalState
) => {
  const {
    headerTitle = '',
    headerDescription = '',
    headerColor = '',
    content,
    pageData,
    formData,
    formProps = {},
    loadRawPageData,
    getRawPageData,
    transformRawPageData = (data: any) => data,
    submit = noop,
    getHeader,
    ...restState
  } = modalOptions ?? {};
  routes[routeId] = {
    pathname,
    state: {
      modal: true,
      ...restState
    },
    modal: {
      headerTitle,
      headerDescription,
      headerColor,
      content,
      pageData,
      formData,
      formProps
    },
    methods: {
      getRawPageData,
      loadRawPageData,
      transformRawPageData,
      getHeader,
      submit
    }
  };
};
